module.exports = __webpack_public_path__ + "static/media/HKGroteskPro-Regular.2fed1725.woff2";